export const MESSAGING_CONSTANT = {
  PAGE_SIZE: 10,
}

export const MESSAGE_REFETCH_INTERVAL_MILLIS = 1000 * 30 // 30 seconds
export const MESSAGE_LISTING_REFETCH_INTERVAL_MILLIS = 1000 * 60 * 5 // 5 minutes
